<template>
  <div class="detail">
    <div class="detail-head clear-fix">
      <div class="fl disFlex">
        <div class="w100">
          <img src="@/assets/imgs/logo.png" width="60" height="60" alt="">
        </div>
        <div class="flex1">
          <p class="font18">{{topData.nickName}}</p>
          <p class="mt10">{{topData.selfIntr}}</p>
        </div>
      </div>

      <div class="fr">
        <ul class="detail-head-content">
          <li>
            <p class="font22">{{topData.numberOfFans}}</p>
            <p>粉丝数</p>
          </li>
          <li>
            <p class="font22">{{topData.praisePoints}}</p>
            <p>获得的点赞数</p>
          </li>
          <li>
            <p class="font22">{{topData.commentNumber}}</p>
            <p>获得的评论数</p>
          </li>
          <li>
            <p class="font22">{{topData.coverforwardingTimes}}</p>
            <p>被转发次数</p>
          </li>
          <li>
            <p class="font22">{{topData.historyReleaseTimes}}</p>
            <p>历史发布作品数</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="detail-content">
      <p class="detail-content-title">用户信息</p>
      <el-row class="mb20">
        <el-col :span="6">性别：{{topData.sex}}</el-col>
        <el-col :span="6">认证信息：{{topData.authInfo}}</el-col>
        <el-col :span="6">所属代理商：{{topData.subordinateAgent}}</el-col>
        <el-col :span="6">手机号：{{topData.phone}}</el-col>
      </el-row>
      <el-row class="mb20">
        <el-col :span="6">首次授权登录时间：{{topData.firstLoginTime}}</el-col>
        <el-col :span="6">城市信息：{{topData.cityInfo}}</el-col>
        <el-col :span="6">状态：{{topData.state}}</el-col>
      </el-row>

      <p class="detail-content-title">钱包详情</p>
      <el-row class="mb20">
        <el-col :span="6">银行卡：{{topData.bankCard}}元</el-col>
        <el-col :span="6">广告余额：{{topData.advertisingBalance}}元</el-col>
        <el-col :span="6">通用余额：{{topData.generalBalance}}元</el-col>
        <el-col :span="6">已提现：{{topData.hasBeenProposed}}元</el-col>
      </el-row>
      <el-row class="mb20">
        <el-col :span="6">提现中：{{topData.withdrawal}}元</el-col>
        <el-col :span="6">购物金：{{topData.shoppingMoney}}元</el-col>
        <el-col :span="6">优惠卡：{{topData.couponCard}}张</el-col>
      </el-row>

      <p class="detail-content-title">广告权限</p>
      <el-row>
        <el-col class="mb20" :span="6" v-for="(item,index) in topData.forbidAdTypeName" :key="index">
          禁止发布{{item}}
        </el-col>
        <el-col class="mb20" :span="6" v-for="(item) in topData.forbidAdPositionName" :key="item">
          禁止投放{{item}}
        </el-col>
      </el-row>

      <p class="detail-content-title">邀请信息</p>
      <el-row class="mb20">
        <el-col :span="6">累计邀请：{{bottomData.cumulativeInvitaNum}}人</el-col>
        <el-col :span="6">获得分成：{{bottomData.awardMoney}}元</el-col>
      </el-row>

      <el-table class="my-table" :data="bottomData.userInvInfoItemDTOList" :header-row-class-name="'my-table-header'">
        <el-table-column align="center" prop="userName" label="用户名"></el-table-column>
        <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
        <el-table-column align="center" prop="createTime" label="邀请日期"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import {getKryOrderInquiryDetail} from '@/api'

  export default {
    name: 'Detail',
    props: ['id'],
    data () {
      return {
        topData: {},
        bottomData: {
          userInvInfoItemDTOList: []
        },
      }
    },
    created () {
      this.refresh()
    },
    watch: {
      id () {
        this.refresh()
      }
    },
    methods: {
      refresh () {
        getKryOrderInquiryDetail({
						  shopIdenty:810094162,
		                  ids: this.id
		               }).then(res => {
						   console.info("===============订单id:",res);
						   
          this.topData = res.data
        })
        // getUserInviteMsg(this.id).then(res => {
        //   this.bottomData = res.data
        // })
      }
    }
  }
</script>

<style scoped>
  .detail {
    padding-bottom: 50px;
  }

  .detail-head {
    background-color: #ebeef5;
    padding: 20px 30px 20px 70px;
  }

  .detail-head-content > li {
    display: inline-block;
    text-align: center;
    margin-right: 40px;
    line-height: 30px;
  }

  .detail-content {
    padding: 0 50px;
  }

  .detail-content-title {
    font-size: 20px;
    font-weight: bold;
    padding-top: 30px;
    padding-bottom: 15px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
  }

  .production {
    border-bottom: 1px solid #ebeef5;
    padding: 5px;
  }

  .production-title {
    position: relative;
    display: inline-block;
    color: #000;
  }

  .production-title > span {
    position: absolute;
    right: -70px;
    top: 0;
    padding: 1px 10px;
    border: 1px solid #8b8d92;
    border-radius: 10px;
    font-size: 12px;
  }

  .production-time {
    color: rgb(148, 148, 148);
    font-size: 12px;
    line-height: 30px;
  }

  .production-imgs img {
    width: 150px;
    height: 100px;
    margin-right: 15px;
    margin-bottom: 10px;
  }
</style>
